import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "modalHeader" }
const _hoisted_3 = { class: "modalBody" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "midTitle" }
const _hoisted_6 = { class: "mt-2 fs-14" }
const _hoisted_7 = { class: "list-group mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_9 = { class: "list-group-item" }
const _hoisted_10 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "list-group-item" }
const _hoisted_14 = { class: "modalFooter" }
const _hoisted_15 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Account collegati",
          text: "Account collegati"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_localized_text, {
            localizedKey: "Hai più account?",
            text: "Hai più account?"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_localized_text, {
            localizedKey: "Collega i tuoi account per poter passare velocemente da un all'altro.",
            text: "Collega i tuoi account per poter passare velocemente da un all'altro."
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          (!_ctx.$store.state.user.linkedAccounts || _ctx.$store.state.user.linkedAccounts.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Nessun account collegato",
                  text: "Nessun account collegato"
                })
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.linkedAccounts, (item, i) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, _toDisplayString(item.name), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-success me-1",
                    onClick: ($event: any) => (_ctx.switchToThis(item))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Passa a questo account",
                      text: "Passa a questo account"
                    })
                  ], 8, _hoisted_11),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-danger",
                    onClick: ($event: any) => (_ctx.removeThis(item))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Scollega",
                      text: "Scollega"
                    })
                  ], 8, _hoisted_12)
                ])
              ])
            ]))
          }), 256)),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addAccountModal && _ctx.addAccountModal(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Aggiungi account",
                text: "Aggiungi account"
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Chiudi",
            text: "Chiudi"
          })
        ])
      ])
    ])
  ]))
}